<dx-tabs
  width="100%"
  [showNavButtons]="false"
  [dataSource]="personsTabs"
  [selectedIndex]="0"
  (onItemClick)="onTabChange($event.itemData.key)"
></dx-tabs>

<app-table
  [columns]="columns"
  [data]="persons"
  [showSearch]="true"
  [searchPlacehoder]="'COMMON.SEARCH' | translate"
  [showExport]="true"
  [exportName]="'Employees list'"
></app-table>
